export class Download {
  _id?: string;
  name: string = '';
  image: string = '';
  file: string = '';
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/downloads/shared/download.model.ts